export const FIELD_NAMES = {
  TITLE: 'title',
  IP: 'ipAddress',
  USER: 'user',
};

export const FILTERED_FIELDS = Object.values(FIELD_NAMES);
